import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const LeadStatus = ({ lead, auth, onDone }) => {
  const [busy, setBusy] = useState(false);
  const set = async (status) => {
    setBusy(true);
    try { await api.patch(`/admin/simran-leads/${lead.id}`, { status }, auth); toast.success(`Marked ${status}`); onDone(); }
    catch { toast.error("Could not update"); }
    finally { setBusy(false); }
  };
  return (
    <select value={lead.status || "new"} disabled={busy} onChange={(e) => set(e.target.value)} data-testid={`simran-lead-status-${lead.id}`}
      className="h-8 rounded-md border border-slate-200 bg-white px-2 text-xs font-semibold">
      <option value="new">New</option><option value="replied">Replied</option><option value="closed">Closed</option>
    </select>
  );
};
